import Footer from "./components/footer/footer";
import Header from "./components/header/header";
import Link from "./components/link/link";
const App = () => {
  return (
    <>
      <Header />
      <Link />
      <Footer />
    </>
  );
};

export default App;
